<div *miproLoading="initializing; diameterPx: '25px'" class="grid">
    <div class="col-12">
        <div class="m-input-group">
            <label class="m-input-group-name asterisk-mark">Diagnosis:</label>
            <div class="m-input-group-value">
                <p-autoComplete
                    #diagnosisInputControl="ngModel"
                    [(ngModel)]="diagnosisValue"
                    [suggestions]="diagnosisSuggestions"
                    (completeMethod)="searchDiagnoses($event.query)"
                    placeholder="Type to search diagnoses"
                    [minLength]="3"
                    [delay]="700"
                    field="name"
                    dataKey="code"
                    [inputStyleClass]="'episode-diagnosis' + (diagnosisValue ? (diagnosisValue.isOSIICSCode ? ' osiics' : ' snomed') : '')"
                    [dropdown]="true"
                    dropdownMode="current"
                    [forceSelection]="(isAppOnline$ | async) && nhsTerminologyServerHealthy"
                    [freeInput]="true"
                    [styleClass]="!_diagnosisValue?.name  && (diagnosisInputControl.dirty || bodySideNameControl.touched)  ? 'required-field': ''"
                    requiredField="name">
                    <ng-template pTemplate="item" let-diagnosisItem>
                        <ng-container *ngTemplateOutlet="diagnosisName; context: { $implicit: diagnosisItem }"></ng-container>
                    </ng-template>

                    <ng-template pTemplate="selectedItem" let-selectedDiagnosisItem>
                        <ng-container *ngTemplateOutlet="diagnosisName; context: { $implicit: selectedDiagnosisItem }"></ng-container>
                    </ng-template>

                    <ng-template pTemplate="clearicon">
                        <TimesIcon />
                    </ng-template>
                </p-autoComplete>
                <control-errors [control]="diagnosisInputControl"></control-errors>
            </div>
        </div>
    </div>

    <div class="col-12" [ngClass]="{ 'sm:col-6': layout === 'two-columns' }">
        <button
            type="button"
            (click)="toggleView()"
            class="p-button-tertiary mr-1 p-button">
            {{ isAdvancedMode ? 'Basic' : 'Advanced' }}
        </button>
    </div>

    <div
        class="col-12"
        [ngClass]="{ 'sm:col-6': layout === 'two-columns' }"
        [class.hidden]="!isAdvancedMode"
        *ngIf="isOSIICSEnabled && (!diagnosisValue || diagnosisValue.isOSIICSCode)">
        <div class="m-input-group">
            <label class="m-input-group-name">Code:</label>
            <div class="m-input-group-value">
                <p-autoComplete
                    [(ngModel)]="diagnosisValue"
                    [suggestions]="osiicsCodeSuggestions"
                    name="diagnosis"
                    (completeMethod)="searchOSIICSCodes($event.query)"
                    placeholder="Type to search codes"
                    field="code"
                    dataKey="code"
                    [forceSelection]="true"
                    [dropdown]="true">
                    <ng-template pTemplate="clearicon">
                        <TimesIcon />
                    </ng-template>
                </p-autoComplete>
            </div>
        </div>
    </div>

    <div class="col-12" [ngClass]="{ 'sm:col-6': layout === 'two-columns' }" [class.hidden]="!isAdvancedMode">
        <div class="m-input-group">
            <label class="m-input-group-name">Medical System:</label>
            <div class="m-input-group-value">
                <p-autoComplete
                    [(ngModel)]="medicalSystemName"
                    [suggestions]="medicalSystemSuggestions"
                    name="medical-system"
                    (completeMethod)="searchMedicalSystems($event.query)"
                    (onClear)="medicalSystemName = null"
                    [forceSelection]="true"
                    placeholder="Type to search medical systems"
                    minLength="1"
                    [showClear]="true"
                    [dropdown]="true">
                    <ng-template pTemplate="clearicon">
                        <TimesIcon />
                    </ng-template>
                </p-autoComplete>
            </div>
        </div>
    </div>

    <div class="col-12" [ngClass]="{ 'sm:col-6': layout === 'two-columns' }" [class.hidden]="!isAdvancedMode">
        <div class="m-input-group">
            <label class="m-input-group-name">Body Part:</label>
            <div class="m-input-group-value">
                <p-autoComplete
                    [(ngModel)]="bodyPartName"
                    [suggestions]="bodyPartSuggestions"
                    name="body-part"
                    (completeMethod)="searchBodyParts($event.query)"
                    (onClear)="bodyPartName = null"
                    [forceSelection]="true"
                    placeholder="Type to search body parts"
                    minLength="1"
                    [showClear]="true"
                    [dropdown]="true">
                    <ng-template pTemplate="clearicon">
                        <TimesIcon />
                    </ng-template>
                </p-autoComplete>
            </div>
        </div>
    </div>

    <div class="col-12" [ngClass]="{ 'sm:col-6': layout === 'two-columns' }" [class.hidden]="!isAdvancedMode">
        <div class="m-input-group">
            <label class="m-input-group-name asterisk-mark">
             Body Side:
            </label>
            <div class="m-input-group-value">
                <p-autoComplete
                    #bodySideNameControl="ngModel"
                    [(ngModel)]="bodySideName"
                    [suggestions]="bodySideSuggestions"
                    name="body-side"
                    (completeMethod)="searchBodySides($event.query)"
                    placeholder="Type to search body sides"
                    minLength="1"
                    [dropdown]="true"
                    required
                    readonly>
                    <ng-template pTemplate="clearicon">
                        <TimesIcon />
                    </ng-template>
                </p-autoComplete>
                <control-errors [control]="bodySideNameControl"></control-errors>
            </div>
        </div>
    </div>
</div>

<ng-template #diagnosisName let-diagnosisItem>
    <ng-container *ngIf="diagnosisItem">
        <m-diagnosis-badge [isOSIICSCode]="diagnosisItem.isOSIICSCode"></m-diagnosis-badge>
        <span class="episode-diagnosis" [ngClass]="{ osiics: diagnosisItem.isOSIICSCode, snomed: !diagnosisItem.isOSIICSCode }">
            {{ diagnosisItem.name }}
        </span>
    </ng-container>
</ng-template>


